import createVueInstance from './createVueInstance'
import LoadingScreen from '@/components/common/LoadingScreen'

export default createVueInstance(LoadingScreen)